import "../Register/Login.css";
import Logo from "../../assets/images/Logo.png";
import ImageCarousel from "../../Components/ImageCarousel";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  combineAllRoutes,
  createCookieInHour,
  emailValidation,
  filterRouteData,
  findSelectedObjectElementIsEmpty,
  setLocalStorage,
} from "../../Functions/Utils";
import { ManageApis } from "../../AppServices/ManageApi";
import AlertBox from "../../Components/AlertBox/AlertBox";
import Loader from "../../Components/LoaderComponent/Loader";
import { routeList } from "../../globalData/constant";
import { useStoreValues } from "../../Context/storeProvider";

function Register() {
  const { user_Roll, setUser_Roll, menuList, setMenuList, setUser } = useStoreValues();
  const [register, setRegister] = useState({
    firstName: "",
    lastName:"",
    email: "",
    userName: "",
    password: "",
    confirmPassword: "",
    accountCreatingPassword:"",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isPassword, setIsPassword] = useState(true);
  const [visible, setvisible] = useState({ show: false, message: "" ,enableSuccessIcon:false,enableFailIcon:false,handlecancel: null});  
  const [isPasswordVisible, setIsPasswordVisible] = useState({
    password: false,
    confirmPassword: false,
    accountCreatingPassword: false
  });

  const Navigate = useNavigate();

  useEffect(() => {
    // localStorage.clear();
    // //console.log(menuList)
  }, [menuList]);




  const handlesubmit = async () => {
    try {
        let isValid = true;
        Object.keys(register).forEach((itm) => {
          if (!Validate(itm, register[itm])) {
            isValid = false;
          }
        });
    
        if (!isValid) {
          return; // Stop submission if validation failed
        }

      setIsLoading(true);
      const { confirmPassword, ...registerData } = register;
      let result = await ManageApis("post", global.Register, registerData);
      console.log(result,"regsiter");
      if (result?.response_data?.status === "Success") {
            setIsLoading(false);
            setvisible((pre) => ({
              show: true,
              enableSuccessIcon:true,
              message: result?.message,  
              handlecancel: () => {
                Navigate("/");
              },
            }));
      } else {
  if (result?.status_code === 401) {
    setvisible((pre) => ({
      show: true,
      message: result?.message,
        enableFailIcon:true,
        handlecancel: () => {
            Navigate("/Register");
        },}));

  } else if (result?.status_code === 400) {
    setvisible((pre) => ({ show: true, message: result?.message,enableFailIcon:true,
        handlecancel: () => {
          Navigate("/Register");
        }, }));

  }
  else {
    setvisible((pre) => ({ show: true, message: result?.message ,enableFailIcon:true,
        handlecancel: () => {
            Navigate("/Register");
        },}));
  }
  setIsLoading(false);
}
    } catch (err) {
  setIsLoading(false);
  // //console.log(err);
}
  };
useEffect(() => {
  // //console.log(login);
}, [register]);

const handleChange = (e) => {
  const { name, value } = e.target;
  Validate(name, value);
  setRegister((pre) => ({ ...pre, [name]: value }));
};

const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const Validate = (name, value) => {
    let isValid = true;
    switch (name) {
      case "firstName":
        if (!value) {
          handleError("Please fill the field", "firstName");
          isValid = false;
        } else {
          handleError("", "firstName");
        }
        break;
      case "lastName":
        if (!value) {
          handleError("Please fill the field", "lastName");
          isValid = false;
        } else {
          handleError("", "lastName");
        }
        break;
      case "email":
        if (!value) {
            handleError("Please fill the field", "email");
            isValid = false;
          } else if (!emailRegex.test(value)) {
            handleError("Please enter a valid email address", "email");
            isValid = false;
          } else {
            handleError("", "email");
          }
        break;
      case "userName":
        if (!value) {
          handleError("Please fill the field", "userName");
          isValid = false;
        } else {
          handleError("", "userName");
        }
        break;
      case "password":
        if (value.length < 4) {
          handleError("Please enter a valid Password", "password");
          isValid = false;
        } else {
          handleError("", "password");
        }
        break;
      case "confirmPassword":
        if (value.length < 4) {
          handleError("Please enter a valid Confirm Password", "confirmPassword");
          isValid = false;
        } else if (value !== register.password) {
          handleError("Passwords do not match", "confirmPassword");
          isValid = false;
        } else {
          handleError("", "confirmPassword");
        }
        break;
      case "accountCreatingPassword":
        if (value.length < 4) {
          handleError("Please enter a valid Account Creating Password", "accountCreatingPassword");
          isValid = false;
        } else {
          handleError("", "accountCreatingPassword");
        }
        break;
      default:
        break;
    }
  
    return isValid;
};
  
const handleError = (error, input) => {
  setErrors((prevState) => ({ ...prevState, [input]: error }));
};

useEffect(() => {
  // //console.log(Object.keys(errors).length > 0, errors);
}, [errors]);

const handlecancel = () => {
  setvisible((pre) => ({ show: false, message: "jbhjijbhujb" }));
};

const handleKeyDown = (event, currentIndex) => {
  const { key } = event;

  if (key == "Enter") {
    if (findSelectedObjectElementIsEmpty(register, ["firstName","lastName","email","userName","password","confirmPassword",])) {
      // //console.log(event);

      const inputFields = document.querySelectorAll(".form-control");
      const nextIndex = (currentIndex + 1) % inputFields.length;
      const nextInput = inputFields[nextIndex];
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      handlesubmit();
    }
  }
};
const HandleLogin = () =>{
    Navigate('/')
  }



  const handleVisibilityToggle = (field) => {
    setIsPasswordVisible({
      ...isPasswordVisible,
      [field]: !isPasswordVisible[field]
    });
  };

return (
  <div className="bg_masterdark h_100vh">
    {
      <AlertBox
        enableSuccessIcon={visible?.enableSuccessIcon}
        enableFailIcon={visible?.enableFailIcon}
        show={visible?.show}
        handlecancel={visible.handlecancel}
        message={visible?.message}
      />
    }
    {isLoading && <Loader />}
    <div className="d-flex h-100 p-4">
      <div className="br_25 m-auto overflow-hidden w-100 flex-column flex-sm-row d-flex loginbx">
        <div className="login_left d-none d-sm-block">
          <div className="p-4 text-white position-relative zi_1">
            <div className="p-0 p-sm-1">
              <img src={Logo} className="mb-4 logo_prop" />
              <h2 className="h4 fw_600 font_21 mb-0 mb-sm-3 pb-0 pb-sm-2">
                Experience the Benefits of Powerful AI with Highest Accuracy.
              </h2>
              <div className="d-none d-sm-block">
                <p className="font_12 fw_200 lh-base">
                  We listen and adapt our ways according to your project
                  needs. You get all the benefits of working with a truly
                  flexible and technology expertise team while avoiding all
                  the mess of having to build and maintain one.
                </p>
                {/* <div className="d-flex gap-3 pt-3">
                  <div>
                    <img src={Product1} className="w-100 rounded-3"/>
                    <h5>Aadhaar Masking</h5>
                  </div>
                  <div>
                    
                  <img src={Product2} className="w-100 rounded-3"/>
                  </div>
                </div> */}
                <div>
                  <ImageCarousel />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="login_right bg-white h-100">
          <div className="d-flex h-100 p-4">
            <div className=" d-flex justify-content-center align-items-center w-100">
              <div>
                <h1 className="h3 text-center text_gray1 fw_600">Register</h1>
                <p className="text-center text_gray1 fw_500 pb-3 d-none d-sm-block">
                  Register to experience the benefits of <br />
                  powerful AI
                </p>
                <div className="row">
                    <div className="mb-3 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                        First Name<span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control rounded-pill font_12"
                        placeholder="Enter your First Name"
                        name="firstName"
                        id="firstName"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.firstName}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                    />
                    {errors&&<span className="text-danger font_11">{errors?.firstName}</span>}
                    </div>
                    <div className="mb-3 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                        Last Name<span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control rounded-pill font_12"
                        placeholder="Enter your Last Name"
                        name="lastName"
                        id="lastName"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.lastName}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                    />
                    {errors&&<span className="text-danger font_11">{errors?.lastName}</span>}
                    </div>
                    <div className="mb-3 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                        Email<span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control rounded-pill font_12"
                        placeholder="Enter your email"
                        name="email"
                        id="email"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.email}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                    />
                    {errors&&<span className="text-danger font_11">{errors?.email}</span>}
                    </div>
                    <div className="mb-3 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                        Username<span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control rounded-pill font_12"
                        placeholder="Enter your Username"
                        name="userName"
                        id="userName"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.userName}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                    />
                    {errors&&<span className="text-danger font_11">{errors?.userName}</span>}
                    </div>
                    <div className="mb-3 pb-1 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                        Password<span className="text-danger">*</span>
                    </label>

                    <div className="input_withicon end">
                        <input
                         type={isPasswordVisible.password ? "text" : "password"}
                        className="form-control rounded-pill font_12 with_icon"
                        placeholder="Enter your password"
                        name="password"
                        id="password"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.password}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        />
                        <i
                        className={`far fa-eye icn p-2 ${isPasswordVisible.password ? 'text-primary' : 'text_gray'}`}
                        onClick={() => handleVisibilityToggle('password')}
                      ></i>
                    </div>
                    {errors&&<span className="text-danger font_11">{errors?.password}</span>}
                    </div>
                    <div className="mb-3 pb-1 col-12 col-md-6">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                    Confirm Password<span className="text-danger">*</span>
                    </label>

                    <div className="input_withicon end">
                        <input
                        type={isPasswordVisible.confirmPassword ? "text" : "password"}
                        className="form-control rounded-pill font_12 with_icon"
                        placeholder="Enter your confirm password"
                        name="confirmPassword"
                        id="confirmPassword"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.confirmPassword}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        />
                        <i
                            className={`far fa-eye icn p-2 ${isPasswordVisible.confirmPassword ? 'text-primary' : 'text_gray'}`}
                            onClick={() => handleVisibilityToggle('confirmPassword')}
                        ></i>
                    </div>
                    {errors&&<span className="text-danger font_11">{errors?.confirmPassword}</span>}
                    </div>
                    <div className="mb-3 pb-1 col-12">
                    <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                    Account Creating Password<span className="text-danger">*</span>
                    </label>

                    <div className="input_withicon end">
                        <input
                         type={isPasswordVisible.accountCreatingPassword ? "text" : "password"}
                        className="form-control rounded-pill font_12 with_icon"
                        placeholder="Enter your Account Creating Password"
                        name="accountCreatingPassword"
                        id="accountCreatingPassword"
                        autoComplete="off"
                        onChange={handleChange}
                        value={register?.accountCreatingPassword}
                        maxLength={50}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        />
                        <i
                            className={`far fa-eye icn p-2 ${isPasswordVisible.accountCreatingPassword ? 'text-primary' : 'text_gray'}`}
                            onClick={() => handleVisibilityToggle('accountCreatingPassword')}
                        ></i>
                    </div>
                    {errors&&<span className="text-danger font_11">{errors?.accountCreatingPassword}</span>}
                    </div>
                </div>

                <div className="px-5 mt-4">
                  <button
                    type="submit"
                    className="btn px_btn btn-master px-4  rounded-pill w-100 fw_500"
                    onClick={handlesubmit}

                  // disabled={Object.values(login).length < 0 }
                  >
                    Register
                  </button>
                </div>
                <div className="text-center mt-5 font_14">
                  Already a User ? <span onClick={HandleLogin} className="font_500 cursor-pointer text_master">Login</span> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  // {/* <div  className="bg_masterdark h_100vh">
  // <div className="d-flex justify-content-center px-4">
  //   <div className="bg-white loginBox shadow_sm2">
  //     <div className="row py-3">
  //       <div className="d-flex login_right_sec px-3">
  //         <div className="px-3 px-md-5 py-2 py-md-5">
  //           <h1 className="font_22 text_master fw_bold mb-2">Sign In</h1>
  //           <p className="text_gray2">
  //             Sign in you have an account in here{" "}
  //           </p>
  //           <div className="row">
  //             <div className="col-12 mt-2">
  //               <div className="d-grid mt-3">
  //                 <label className="mb-0 px-1 text_gray2">
  //                   UserName<span className="text-danger">*</span>
  //                 </label>
  //                 <input
  //                   type="text"
  //                   className="form-control bg_light br_10"
  //                   placeholder="Enter your username "
  //                   //onChange={}
  //                 />
  //               </div>
  //             </div>
  //             <div className="col-12">
  //               <div className="d-grid mt-3">
  //                 <label className="mb-0 px-1 text_gray2">
  //                   Password<span className="text-danger">*</span>
  //                 </label>
  //                 <input
  //                   type="password"
  //                   className="form-control bg_light br_10"
  //                   placeholder="Enter your password"
  //                   //onChange={}
  //                 />
  //               </div>
  //             </div>
  //           </div>
  //           <div className="d-flex justify-content-end mt-3">
  //             <button
  //               type="submit"
  //               className="btn px_btn btn-master px-4 br_10 "
  //               //onClick={handlesubmit}
  //             >
  //               SIGN IN
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </div>
  // </div> */}
);
}

export default Register;
